declare interface String {
        format(...args: any[]): string;
    }


function escapeRegExp(str: string) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}



String.prototype.format = function (...args: any[]): string {
    let a = this;
    for (let k in arguments) {
        var re = new RegExp(escapeRegExp('{' + k + '}'), 'g');
        a = a.replace(re, arguments[k])
    }
    return a as string;
};

var winSize: { w: number, h: number };

function getWindowSize(): { w: number, h: number } {
    let winW: number = 0;
    let winH: number = 0;
    if (document.body && document.body.offsetWidth) {
        winW = document.body.offsetWidth;
        winH = document.body.offsetHeight;
    }
    if (document.compatMode == 'CSS1Compat' &&
        document.documentElement &&
        document.documentElement.offsetWidth) {
        winW = document.documentElement.offsetWidth;
        winH = document.documentElement.offsetHeight;
    }
    if (window.innerWidth && window.innerHeight) {
        winW = window.innerWidth;
        winH = window.innerHeight;
    }
    return { w: winW, h: winH };
}

winSize = getWindowSize();

function isInView(element: Element, topLimit?: number, bottomLimit?: number) {

    var box = element.getBoundingClientRect();

    let topLimitVar = topLimit ? topLimit : 0;
    let bottomLimitVar = bottomLimit ? bottomLimit : winSize.h;

    if ((box.bottom <= topLimitVar) || (box.top >= bottomLimitVar)) {
        return false;
    }


    return true;

}

function isInViewHorizontal(element: Element, leftLimit?: number, rightLimit?: number) {

    var box = element.getBoundingClientRect();


    let leftLimitVar = leftLimit ? leftLimit : 0;
    let rightLimitVar = rightLimit ? rightLimit : winSize.w;

    if ((box.right <= leftLimitVar) || (box.left >= rightLimitVar)) {
        return false;
    }
    return true;

}

window['getWindowSize'] = getWindowSize;
window['isInView'] = isInView;
window['isInViewHorizontal'] = isInViewHorizontal;
